// archivo: src/components/admin_sections/PagosGlobales.js (Versión Mejorada y Corregida)

import React, { useState, useMemo, useEffect } from 'react';
import Swal from 'sweetalert2';
import '../../styles/Reportes.css'; // Reutilizamos los estilos de los reportes
import '../../styles/PagosGlobales.css'; 
import { useAdminContext } from '../../context/AdminContext.js';
import Pagination from '../../components/common/Pagination.js'; // Ya estaba correcto
import { KpiCard } from '../../components/common/KpiCard.js';
import TableSkeleton from '../../components/common/TableSkeleton.js'; // Ya estaba correcto
import { getAgreementProgressDetails } from '../../utils/agreementUtils.js'; // <-- RUTA CORREGIDA
import { ArrowUpDown, List, Briefcase, Search, Percent, Eye, X, Calendar, Hash, User, DollarSign, TrendingUp, CheckCircle } from 'lucide-react';

// Componente MySwal para SweetAlert2 con React
const MySwal = Swal.mixin({
    customClass: {
        confirmButton: 'login-button', // Reutiliza tu clase de botón
        cancelButton: 'sign-out-button' // Reutiliza tu clase de botón de cerrar sesión
    },
    buttonsStyling: false
});

// --- NUEVO: Modal para mostrar detalles del acuerdo ---
const AgreementDetailsModal = ({ agreement, onClose }) => {
    if (!agreement) return null;

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp.seconds * 1000).toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content details-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Detalles del Acuerdo</h3>
                    <button onClick={onClose} className="close-button"><X size={24} /></button>
                </div>
                <div className="modal-body">
                    <div className="details-card">
                        <h4 className="card-title">Información Principal</h4>
                        <div className="detail-item"><strong className="detail-item-label"><Hash size={16} /> ID Acuerdo:</strong> <span>{agreement.id}</span></div>
                        <div className="detail-item"><strong className="detail-item-label"><User size={16} /> Usuario:</strong> <span>{agreement.userEmail}</span></div>
                        <div className="detail-item"><strong className="detail-item-label"><Calendar size={16} /> Fecha Aprobación:</strong> <span>{formatDate(agreement.approvedAt)}</span></div>
                        <div className="detail-item"><strong className="detail-item-label"><CheckCircle size={16} /> Estado:</strong> <span>{agreement.status}</span></div>
                    </div>
                    <div className="details-card">
                        <h4 className="card-title">Detalles Financieros</h4>
                        <div className="detail-item"><strong className="detail-item-label"><DollarSign size={16} /> Monto aportado:</strong> <span className="value-positive">${agreement.amount.toFixed(2)}</span></div>
                        {agreement.acceleratorActive && (
                            <div className="detail-item"><strong className="detail-item-label"><Percent size={16} /> Fee Acelerador:</strong> <span className="value-negative">-${(agreement.acceleratorFee || 0).toFixed(2)}</span></div>
                        )}
                        <div className="detail-item"><strong className="detail-item-label"><Briefcase size={16} /> Monto neto:</strong> <span>${(agreement.netInvestmentAmount || agreement.amount).toFixed(2)}</span></div>
                        <div className="detail-item"><strong className="detail-item-label"><TrendingUp size={16} /> Valor Actual:</strong> <span className="value-target">${(agreement.currentValue || 0).toFixed(2)}</span></div>
                    </div>
                </div>
            </div>
        </div>
    );
};


const PagosGlobales = () => {
    // Obtenemos todo (datos y acciones) desde el contexto
    const { 
        allAgreements, 
        loading, 
        processingId, 
        settings,
        handleAssignGains: assignGainsAction, 
        handleRevertPayment // <-- AÑADIDO
    , runAssignGainsByDate } = useAdminContext() || { allAgreements: [], loading: true };

    const [activeTab, setActiveTab] = useState('conAcelerador');
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [dailyPercentage, setDailyPercentage] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchAmount, setSearchAmount] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userEmail', direction: 'asc' });
    const [debouncedSearchEmail, setDebouncedSearchEmail] = useState('');
    const [debouncedSearchAmount, setDebouncedSearchAmount] = useState('');
    const [modalData, setModalData] = useState(null); // <-- NUEVO: Estado para el modal
    const [selectedDate, setSelectedDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 1); // default yesterday
        return d.toISOString().slice(0,10);
    });

    // --- ESTADOS PARA PAGINACIÓN ---
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15);

    // --- EFECTOS PARA DEBOUNCING ---
    useEffect(() => {
        const timerId = setTimeout(() => setDebouncedSearchEmail(searchEmail), 300);
        return () => clearTimeout(timerId);
    }, [searchEmail]);

    useEffect(() => {
        const timerId = setTimeout(() => setDebouncedSearchAmount(searchAmount), 300);
        return () => clearTimeout(timerId);
    }, [searchAmount]);

    // Resetear paginación al cambiar filtros
    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab, debouncedSearchEmail, debouncedSearchAmount]);

    // Filtrar acuerdos activos y no completados
    const agreements = useMemo(() => {
        return (allAgreements || []).filter(a => {
            if (a.status !== 'aprobado') return false;
            const { isComplete } = getAgreementProgressDetails(a);
            return !isComplete;
        });
    }, [allAgreements]);

    // Separar acuerdos por tipo de usuario
    const founderAgreements = useMemo(() => agreements.filter(a => a.isFoundingPartner), [agreements]);
    const acceleratorAgreements = useMemo(() => agreements.filter(a => a.acceleratorActive && !a.isFoundingPartner), [agreements]);
    const noAcceleratorAgreements = useMemo(() => agreements.filter(a => !a.acceleratorActive && !a.isFoundingPartner), [agreements]);

    // Filtrado por email y monto antes de paginar
    const filteredAgreements = useMemo(() => {
        let baseList = [];
        if (activeTab === 'conAcelerador') baseList = acceleratorAgreements;
        else if (activeTab === 'sinAcelerador') baseList = noAcceleratorAgreements;
        else if (activeTab === 'sociosFundadores') baseList = founderAgreements;
        let result = baseList;
        if (debouncedSearchEmail.trim()) {
            result = result.filter(a => (a.userEmail || '').toLowerCase().includes(debouncedSearchEmail.trim().toLowerCase()));
        }
        if (debouncedSearchAmount.trim()) {
            const searchValue = parseFloat(debouncedSearchAmount);
            if (!isNaN(searchValue)) {
                result = result.filter(a => a.amount === searchValue);
            }
        }
        if (sortConfig.key) {
            result.sort((a, b) => {
                let valA = a[sortConfig.key];
                let valB = b[sortConfig.key];
                if (sortConfig.key === 'progress') {
                    valA = getAgreementProgressDetails(a).progress;
                    valB = getAgreementProgressDetails(b).progress;
                }
                if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
                if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        return result;
    }, [activeTab, acceleratorAgreements, noAcceleratorAgreements, founderAgreements, debouncedSearchEmail, debouncedSearchAmount, sortConfig]);

    // --- LÓGICA DE PAGINACIÓN ---
    const totalPages = Math.ceil(filteredAgreements.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedAgreements = filteredAgreements.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedIds = new Set(selectedIds);
        if (newSelectedIds.has(id)) {
            newSelectedIds.delete(id);
        } else {
            newSelectedIds.add(id);
        }
        setSelectedIds(newSelectedIds);
    };

    const handleSelectAll = () => {
        // LÓGICA CORREGIDA: Operar sobre todos los acuerdos filtrados, no solo los paginados.
        const allFilteredIds = filteredAgreements.map(a => a.id);
        const areAllCurrentlySelected = allFilteredIds.length > 0 && allFilteredIds.every(id => selectedIds.has(id));

        if (areAllCurrentlySelected) {
            // Si todos ya están seleccionados, los deseleccionamos a todos.
            const newSelectedIds = new Set(selectedIds);
            allFilteredIds.forEach(id => newSelectedIds.delete(id));
            setSelectedIds(newSelectedIds);
        } else {
            // Si no, añadimos todos los acuerdos filtrados al set de selección.
            // Usamos `new Set([...selectedIds, ...allFilteredIds])` para no perder
            // selecciones de otras páginas si el usuario navega.
            setSelectedIds(new Set([...selectedIds, ...allFilteredIds]));
        }
    };

    const handleAssignGains = async () => {
        const percentageValue = parseFloat(dailyPercentage);
        if (isNaN(percentageValue) || percentageValue <= 0 || percentageValue > 5) {
            MySwal.fire('Error', 'Por favor, ingresa un porcentaje diario válido entre 0.01 y 5.', 'error');
            return;
        }
        if (selectedIds.size === 0) {
            MySwal.fire('Error', 'No has seleccionado ningún acuerdo para asignar resultados.', 'error');
            return;
        }

        const idsArray = Array.from(selectedIds);

        try {
            // Chequeo silencioso: si alguna de estas cuentas ya recibió un pago hoy, avisamos
            // antes de pagar en vez de saltearlas sin decir nada.
            const preview = await assignGainsAction(idsArray, percentageValue, { dryRun: true });
            const duplicates = preview?.alreadyPaidDetails || [];

            let excludeAgreementIds = [];
            if (duplicates.length > 0) {
                const listHtml = duplicates.map(d => `
                    <label style="display:flex;align-items:center;gap:8px;padding:6px 4px;border-bottom:1px solid #eee;text-align:left;">
                        <input type="checkbox" class="dup-exclude-checkbox-manual" data-agreement-id="${d.agreementId}" />
                        <span>${d.userEmail || d.userId} <small style="color:#888;">(#${d.agreementId.substring(0, 6)})</small></span>
                    </label>
                `).join('');

                const alertResult = await MySwal.fire({
                    title: `⚠️ ${duplicates.length} cuenta(s) ya recibieron pago hoy`,
                    html: `
                        <p style="text-align:left;">Estas cuentas ya tienen un pago de ROI registrado hoy. Si continuás, se les va a pagar <strong>de nuevo</strong> (pago duplicado), salvo las que tildes para excluir:</p>
                        <div style="max-height:260px;overflow-y:auto;margin-top:8px;">${listHtml}</div>
                    `,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Continuar y pagar (excepto lo tildado)',
                    cancelButtonText: 'Cancelar todo',
                    preConfirm: () => {
                        const checked = Array.from(document.querySelectorAll('.dup-exclude-checkbox-manual:checked'));
                        return checked.map(el => el.getAttribute('data-agreement-id'));
                    }
                });
                if (!alertResult.isConfirmed) return;
                excludeAgreementIds = alertResult.value || [];
            }

            await assignGainsAction(idsArray, percentageValue, {
                forceDuplicates: duplicates.length > 0,
                excludeAgreementIds,
            });

            setSelectedIds(new Set());
            setDailyPercentage('');
        } catch (err) {
            // El error ya se muestra dentro de assignGainsAction; acá solo evitamos limpiar la selección.
        }
    };

    const handleRevertGains = async () => {
        if (selectedIds.size === 0) {
            MySwal.fire('Error', 'No has seleccionado ningún acuerdo para revertir resultados.', 'error');
            return;
        }

        // La función del contexto ahora maneja la confirmación y el estado de procesamiento.
        await handleRevertPayment(Array.from(selectedIds));

        // Limpiamos la selección después de que la acción se complete.
        setSelectedIds(new Set());
    };

    // --- LÓGICA DE ORDENAMIENTO ---
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    function SortableHeader({ children, sortKey }) {
        return (
            <th onClick={() => requestSort(sortKey)} className="sortable-header">
                {children}
                {sortConfig.key === sortKey ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : <ArrowUpDown size={14} style={{ marginLeft: '4px', opacity: 0.5 }} />}
            </th>
        );
    }

    // --- CÁLCULO DE KPIs ---
    const kpiStats = useMemo(() => {
        const totalCapital = filteredAgreements.reduce((sum, a) => sum + (a.netInvestmentAmount || a.amount || 0), 0);
        const totalCount = filteredAgreements.length;
        return { totalCapital, totalCount };
    }, [filteredAgreements]);
    
    // --- 2. Usar el esqueleto mientras se carga ---
    if (loading) return <div className="main-panel"><TableSkeleton columns={6} rows={10} /></div>;

    // --- LÓGICA MEJORADA PARA EL CHECKBOX PRINCIPAL ---
    // Esto determina si el checkbox de "seleccionar todo" debe estar marcado, desmarcado o en estado intermedio.
    const allFilteredIds = filteredAgreements.map(a => a.id);
    const areAllFilteredSelected = filteredAgreements.length > 0 && allFilteredIds.every(id => selectedIds.has(id));
    // El estado intermedio se da cuando algunos (pero no todos) los acuerdos de la lista filtrada están seleccionados.
    const isIndeterminate = filteredAgreements.length > 0 && !areAllFilteredSelected && allFilteredIds.some(id => selectedIds.has(id));

    // --- NUEVO: Componente/variable para el checkbox de seleccionar todo para no duplicar código ---
    const SelectAllCheckbox = (
        <div className="select-all-checkbox-wrapper">
            <input
                type="checkbox"
                title={`Seleccionar todos los ${filteredAgreements.length} acuerdos de esta pestaña`}
                onChange={handleSelectAll}
                checked={areAllFilteredSelected}
                ref={el => {
                    if (el) el.indeterminate = isIndeterminate;
                }}
            />
            <label className="select-all-label">Todos ({filteredAgreements.length})</label>           

        </div>
    );
    return (
        <div className="main-panel">
            <h2 className="section-title">Pagos Globales - Asignación de Participación del Día</h2>

            <div className="kpi-grid pagos-globales-kpi-grid">
                <KpiCard 
                    title="Nº de Acuerdos (Filtrados)" 
                    value={kpiStats.totalCount} 
                    icon={<List size={24} />} 
                    color="#9333ea" 
                />
                <KpiCard 
                    title="Capital Total (Filtrado)" 
                    value={`$${kpiStats.totalCapital.toFixed(2)}`} 
                    icon={<Briefcase size={24} />} 
                    color="#2563eb" 
                />
            </div>
            <div className="report-filters">
                <div className="filter-item">
                    <Percent size={16} />
                    <input 
                        type="number" step="0.01" placeholder="Ej: 0.5 para 0.5%"
                        value={dailyPercentage} 
                        onChange={(e) => setDailyPercentage(e.target.value)}
                        disabled={processingId === 'assign-gains'}
                    />
                </div>
                <div className="filter-item">
                    <Calendar size={16} />
                    <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} />
                </div>
                <div className="filter-item">
                    <button className="login-button" onClick={async () => {
                        const agreementIdsParam = selectedIds.size ? Array.from(selectedIds) : undefined;
                        const targetText = agreementIdsParam ? 'los acuerdos seleccionados' : 'todas las cuentas pendientes en esa fecha';
                        const confirm = await MySwal.fire({ title: `Ejecutar pagos para ${selectedDate}?`, text: `Esto intentará asignar resultados para ${targetText}.`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Sí, ejecutar', cancelButtonText: 'Cancelar' });
                        if (!confirm.isConfirmed) return;

                        try {
                            // 1) Primero corremos un chequeo (dryRun) para detectar si alguna cuenta
                            // ya tiene un pago ese día — antes esto se saltaba en silencio, ahora se
                            // avisa y el admin decide si paga igual o excluye alguna.
                            const preview = await runAssignGainsByDate(selectedDate, true, agreementIdsParam);
                            const duplicates = preview?.alreadyPaidDetails || [];

                            let excludeAgreementIds = [];
                            if (duplicates.length > 0) {
                                const listHtml = duplicates.map(d => `
                                    <label style="display:flex;align-items:center;gap:8px;padding:6px 4px;border-bottom:1px solid #eee;text-align:left;">
                                        <input type="checkbox" class="dup-exclude-checkbox" data-agreement-id="${d.agreementId}" />
                                        <span>${d.userEmail || d.userId} <small style="color:#888;">(#${d.agreementId.substring(0, 6)})</small></span>
                                    </label>
                                `).join('');

                                const alertResult = await MySwal.fire({
                                    title: `⚠️ ${duplicates.length} cuenta(s) ya recibieron pago ese día`,
                                    html: `
                                        <p style="text-align:left;">Estas cuentas ya tienen un pago de ROI registrado para el ${selectedDate}. Si continuás, se les va a pagar <strong>de nuevo</strong> (pago duplicado), salvo las que tildes para excluir:</p>
                                        <div style="max-height:260px;overflow-y:auto;margin-top:8px;">${listHtml}</div>
                                    `,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Continuar y pagar (excepto lo tildado)',
                                    cancelButtonText: 'Cancelar todo',
                                    preConfirm: () => {
                                        const checked = Array.from(document.querySelectorAll('.dup-exclude-checkbox:checked'));
                                        return checked.map(el => el.getAttribute('data-agreement-id'));
                                    }
                                });
                                if (!alertResult.isConfirmed) return;
                                excludeAgreementIds = alertResult.value || [];
                            }

                            // 2) Ejecutamos de verdad: forceDuplicates paga igual a los que ya tenían
                            // pago ese día (salvo los excluidos explícitamente en la alerta).
                            const result = await runAssignGainsByDate(selectedDate, false, agreementIdsParam, {
                                forceDuplicates: duplicates.length > 0,
                                excludeAgreementIds,
                            });
                            MySwal.fire('Completado', result?.message || 'Proceso finalizado. Revisa logs.', 'success');
                        } catch (err) {
                            MySwal.fire('Error', err.message || 'Error ejecutando pagos por fecha.', 'error');
                        }
                    }}>Pagar fecha</button>
                    {/* Dry Run button removed per request */}
                </div>
                <div className="filter-item">
                    <Search size={16} />
                    <input
                        type="text"
                        placeholder="Correo usuario"
                        value={searchEmail}
                        onChange={e => setSearchEmail(e.target.value)}
                    />
                </div>
                <div className="filter-item">
                    <Search size={16} />
                    <input
                        type="number"
                        placeholder="Monto exacto"
                        value={searchAmount}
                        onChange={e => setSearchAmount(e.target.value)}
                    />
                </div>
                <div className="payment-actions-container">
                    <button 
                        className="login-button" onClick={handleAssignGains}
                        disabled={processingId === 'assign-gains' || selectedIds.size === 0 || dailyPercentage === '' || isNaN(parseFloat(dailyPercentage)) || parseFloat(dailyPercentage) <= 0 || parseFloat(dailyPercentage) > 5}
                    >
                        {processingId === 'assign-gains' ? 'Procesando...' : `Asignar (${selectedIds.size})`}
                    </button>
                    <button 
                        className="login-button danger"
                        onClick={handleRevertGains}
                        disabled={processingId === 'revert-gains' || selectedIds.size === 0}
                    >
                        {processingId === 'revert-gains' ? 'Procesando...' : `Revertir (${selectedIds.size})`}
                    </button>
                </div>
            </div>

            <div className="admin-tabs pagos-globales-tabs">
                <button 
                    className={`tab-button ${activeTab === 'conAcelerador' ? 'active' : ''}`}
                    onClick={() => { setActiveTab('conAcelerador'); setCurrentPage(1); }}>
                    Con Acelerador ({acceleratorAgreements.length})
                </button>
                <button 
                    className={`tab-button ${activeTab === 'sinAcelerador' ? 'active' : ''}`}
                    onClick={() => { setActiveTab('sinAcelerador'); setCurrentPage(1); }}>
                    Sin Acelerador ({noAcceleratorAgreements.length})
                </button>
                <button 
                    className={`tab-button ${activeTab === 'sociosFundadores' ? 'active' : ''}`}
                    onClick={() => { setActiveTab('sociosFundadores'); setCurrentPage(1); }}>
                    Socios Fundadores ({founderAgreements.length})
                </button>
            </div>
            
            {/* --- NUEVO: Contenedor del checkbox de seleccionar todo solo para móvil --- */}
            <div className="mobile-select-all-container">
                {SelectAllCheckbox}
            </div>

            <div className="report-table-container">
                <table className="report-table">
                    <thead>
                        <tr className="pagos-globales-header-row">
                            <th className="select-all-header">{SelectAllCheckbox}</th><th>Acciones</th>
                            <SortableHeader sortKey="userEmail">Usuario</SortableHeader><SortableHeader sortKey="amount">Monto aportado</SortableHeader><SortableHeader sortKey="netInvestmentAmount">Monto neto</SortableHeader><SortableHeader sortKey="currentValue">Valor Actual</SortableHeader><SortableHeader sortKey="progress">Progreso</SortableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (<tr><td colSpan="6" className="table-center-text">Cargando...</td></tr>) : paginatedAgreements.length > 0 ? paginatedAgreements.map(agreement => {
                            const { progress } = getAgreementProgressDetails(agreement);

                            return (
                                <tr key={agreement.id} className={selectedIds.has(agreement.id) ? 'selected-row' : ''}>
                                    <td><input type="checkbox" checked={selectedIds.has(agreement.id)} onChange={() => handleSelectRow(agreement.id)} /></td>
                                    <td>
                                        <button onClick={() => setModalData(agreement)} className="action-btn history" title="Ver detalles del acuerdo"><Eye size={16} /></button>
                                    </td>
                                    <td>{agreement.userEmail}</td>
                                    <td>${agreement.amount.toFixed(2)}</td>
                                    <td>${(agreement.netInvestmentAmount || agreement.amount).toFixed(2)}</td>
                                    <td>${(agreement.currentValue || (agreement.netInvestmentAmount || agreement.amount)).toFixed(2)}</td>
                                    <td>{progress.toFixed(1)}%</td>
                                </tr>
                            )
                        }) : (
                            <tr><td colSpan="7" className="table-center-text">No hay acuerdos activos en esta categoría.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            
            {totalPages > 1 && (
                 <Pagination
                    totalItems={filteredAgreements.length}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={setItemsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onNext={handleNextPage}
                    onPrevious={handlePreviousPage}
                    canNext={currentPage < totalPages}
                    canPrevious={currentPage > 1}
                />
            )}

            {modalData && <AgreementDetailsModal agreement={modalData} onClose={() => setModalData(null)} />}
        </div>
    );
};

export default PagosGlobales;